export const inputFiltersOptions = {
  'zone': 'Zona',
  'provider': 'Proveedor',
  'invoice': 'Factura',
  'checkingUser': 'C&S x Usuario',
  'storingUser': 'I/F x Usuario',
  'month': 'Mes',
};

export const outputFiltersOptions = {
  'zone': 'Zona',
  'dealer': 'Concesionario',
  'agency': 'Agencia',
  'pickingUser': 'Desp x Usuario',
  'month': 'Mes',
};

export const typesOfGraphics = [
  {'name': 'Pastel', 'value': 'pie'},
  {'name': 'Barras', 'value': 'bar'},
  {'name': 'Líneas', 'value': 'line'},
];

export const sortOptions = [
  {'text': 'Afabeticamente', 'value': 'alphabetically'},
  {'text': 'Numericamente', 'value': 'numerically'},
];

export const linesOptions = {
  'received': 'recepcionadas',
  'backOrder': 'recepcionadas BO',
  'dispatched': 'despachadas',
};

export const panes = [
  {'menuItem': 'Ventas por agencia'},
  {'menuItem': 'Ventas vs. presupuesto'},
];

export const PANES_INDICES = {
  'SALES_BY_AGENCY': 0,
  'SALES_VS_BUDGETS': 1,
};
